<template>
  <div class="home">
    <v-app-bar color="white" elevation="1" dark>
      <div class="d-flex align-center">
        <v-img
          alt="GoDark Logo"
          class="shrink mr-2"
          contain
          src="../../assets/auth/logo.png"
          transition="scale-transition"
          min-width="100"
          width="200"
        />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style scoped></style>
